import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';

const GOLD = '#D4AF37';
const NAVY = '#16213E';

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useAuth();
  const [hoveredPath, setHoveredPath] = useState(null);

  const isActive = (path) => location.pathname === path;
  const hasRole = (r) => role && role.split(',').map(s => s.trim().toUpperCase()).includes(r);

  const menuItems = [
    { path: '/profile',  label: 'Profile',    icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round" /></svg> },
    { path: '/donate',   label: 'Donations',  icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> },
    { path: '/articles', label: 'Articles',   icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg> },
    { path: '/youtube',  label: 'Videos',     icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.723v6.554a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" /></svg> },
  ];
  if (hasRole('ADMIN') || hasRole('CONTENT-CREATOR') || hasRole('CONTENT-APPROVER'))
    menuItems.push({ path: '/books', label: 'Books', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>, dividerAfter: true });
  if (hasRole('ADMIN') || hasRole('CONTENT-CREATOR') || hasRole('CONTENT-APPROVER'))
    menuItems.push({ path: '/content-management', label: 'Content', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg> });
  if (hasRole('ADMIN'))
    menuItems.push({ path: '/admin', label: 'Admin', icon: <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg> });

  return (
    <div className="h-full flex" style={{ position: 'relative' }}>
      <div
        className="flex flex-col h-full"
        style={{ width: '100%', background: `linear-gradient(180deg, ${NAVY} 0%, #0F172A 100%)` }}>

        {/* Header */}
        <div style={{ height: '48px', borderBottom: '1px solid rgba(212,175,55,0.1)', display: 'flex', alignItems: 'center', padding: collapsed ? '0' : '0 16px' }}>
        </div>

        {/* Nav items */}
        <ul className="flex-1 py-3 space-y-1">
          {menuItems.map((item) => {
            const active = isActive(item.path);
            return (
              <React.Fragment key={item.path}>
              <li style={{ position: 'relative' }}>
                <button
                  onClick={() => navigate(item.path)}
                  onMouseEnter={() => collapsed && setHoveredPath(item.path)}
                  onMouseLeave={() => setHoveredPath(null)}
                  className="w-full flex items-center py-3 rounded-2xl text-sm font-medium transition-all duration-200"
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    justifyContent: collapsed ? 'center' : 'flex-start',
                    gap: collapsed ? '0' : '12px',
                    paddingLeft: collapsed ? '0' : '14px',
                    paddingRight: collapsed ? '0' : '14px',
                    background: active ? 'rgba(212,175,55,0.14)' : 'transparent',
                    color: active ? GOLD : 'rgba(255,255,255,0.8)',
                    borderLeft: active && !collapsed ? `2px solid ${GOLD}` : '2px solid transparent',
                  }}
                  onFocus={() => collapsed && setHoveredPath(item.path)}
                  onBlur={() => setHoveredPath(null)}>
                  <span className="flex-shrink-0" style={{ color: active ? GOLD : 'rgba(255,255,255,0.8)' }}>{item.icon}</span>
                  {!collapsed && <span className="tracking-wide">{item.label}</span>}
                </button>

                {/* Floating label tooltip */}
                {collapsed && hoveredPath === item.path && (
                  <div
                    style={{
                      position: 'absolute',
                      left: 'calc(100% + 14px)',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      pointerEvents: 'none',
                      zIndex: 9999,
                      whiteSpace: 'nowrap',
                      animation: 'tooltipIn 0.15s ease out',
                    }}>
                    {/* Arrow */}
                    <div style={{
                      position: 'absolute',
                      left: '-5px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 0, height: 0,
                      borderTop: '5px solid transparent',
                      borderBottom: '5px solid transparent',
                      borderRight: `5px solid ${NAVY}`,
                    }} />
                    <div style={{
                      background: `linear-gradient(135deg, ${NAVY}, #0F172A)`,
                      border: `1px solid rgba(212,175,55,0.4)`,
                      borderRadius: '10px',
                      padding: '6px 14px',
                      color: GOLD,
                      fontSize: '0.75rem',
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 600,
                      letterSpacing: '0.05em',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
                    }}>
                      {item.label}
                    </div>
                  </div>
                )}
              </li>
              {item.dividerAfter && (
                <li>
                  <div style={{ margin: '6px 14px', height: '1px', background: 'rgba(212,175,55,0.15)' }} />
                </li>
              )}
              </React.Fragment>
            );
          })}
        </ul>

        {!collapsed && (
          <div className="px-4 py-4" style={{ borderTop: '1px solid rgba(212,175,55,0.08)' }}>
            <div className="vrv-divider mb-3" />
            <p className="text-[10px] italic text-center" style={{ color: 'rgba(212,175,55,0.3)', fontFamily: '"Cormorant Garamond", serif' }}>
              "United in Devotion"
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
